import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import StepLabel from '@mui/material/StepLabel';

const StyledStepLabel = styled(StepLabel)` 
  ${ComponentStyles}
`;

StyledStepLabel.propTypes = {
  theme: PropTypes.object
};

export default StyledStepLabel;
